module.exports = __webpack_public_path__ + "ru.png?05adc53240585c179858249e9a3dd08b";